import { apiClient } from "@/api";
import type { ApiResponse, AuthTokens, User } from "@/types";
import type { AxiosRequestConfig } from "axios";

export async function ssoLoginUser(accessToken: string, config?: AxiosRequestConfig): Promise<AuthTokens> {
  const { data } = await apiClient.post<ApiResponse<AuthTokens>>(
    "/auth/sso/login",
    // Which login button started the flow (Figma 203:6570): outlook · pwc_sso — set by useSsoLogin
    { access_token: accessToken, login_type: sessionStorage.getItem("sso_login_type") ?? "outlook" },
    config
  );
  return data.data!;
}

export async function logoutUser(refreshToken: string, config?: AxiosRequestConfig): Promise<void> {
  await apiClient.post("/auth/logout", { refresh_token: refreshToken }, config);
}

export async function getCurrentUser(config?: AxiosRequestConfig): Promise<User> {
  const { data } = await apiClient.get<ApiResponse<User>>("/users/me", config);
  return data.data!;
}
